import * as React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import CustomModal from "../../Components/CustomModal/CustomModal";
import experience from "../../data/experience";

class Experience extends React.Component {
  createTimelineElement = (item) => {
    const { title: leftTitle, description: leftDescription } =
      item.modalContent.leftContent;
    const { title: rightTitle, description: rightDescription } =
      item.modalContent.rightContent;
    return (
      <VerticalTimelineElement
        className="vertical-timeline-element--work"
        contentStyle={{ background: "#19577d", color: "#fff" }}
        contentArrowStyle={{ borderRight: "7px solid  #19577d" }}
        date={item.duration}
        iconStyle={{ background: "#fff" }}
        icon={
          <img
            alt={item.iconClass}
            className={`${item.iconClass}-icon`}
            src={`/${item.iconClass}.svg`}
          />
        }
      >
        <h3 className="vertical-timeline-element-title">{item.role}</h3>
        <h4 className="vertical-timeline-element-subtitle">{item.company}</h4>
        <p>
          <span className="vertical-timeline-element-description-title">
            Objective:{" "}
          </span>
          {item.objective}
        </p>
        <p>
          <span className="vertical-timeline-element-description-title">
            Worked on:{" "}
          </span>
          {item.techStack.join(", ")}
        </p>
        <CustomModal
          buttonLabel="KNOW MORE"
          modalTitle={`${item.degree}: ${item.institute}`}
          leftTitle={leftTitle}
          leftDescription={leftDescription}
          rightTitle={rightTitle}
          rightDescription={rightDescription}
        />
      </VerticalTimelineElement>
    );
  };
  render() {
    return (
      <div className="experience" id="experience">
        <div className="experience-container">
          <div className="experience-title">Experience</div>
          <VerticalTimeline animate={false}>
            {experience.map(this.createTimelineElement)}
          </VerticalTimeline>
        </div>
      </div>
    );
  }
}

export default Experience;
